/**
 * The registry carries its i18n keys as plain `string`s (the interface
 * contract types them so), but i18next's typed `t` (app/src/core/i18next.d.ts)
 * only accepts literal keys that exist in `en/project.json` — a bare
 * `t(descriptor.titleKey)` is TS2345. This is the one place that cast lives.
 * `(...args: never[]) => unknown` accepts the overloaded `TFunction` as-is.
 */
export function translateKey(t: (...args: never[]) => unknown, key: string, vars?: Record<string, unknown>): string {
  return (t as unknown as (k: string, v?: Record<string, unknown>) => string)(key, vars);
}
